export enum OAuthProvider {
  GOOGLE
}
